/* tslint:disable */
/* eslint-disable */
/**
 * Rooming_API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Country,
    CountryFromJSON,
    CountryFromJSONTyped,
    CountryToJSON,
    Discipline,
    DisciplineFromJSON,
    DisciplineFromJSONTyped,
    DisciplineToJSON,
    Event,
    EventFromJSON,
    EventFromJSONTyped,
    EventToJSON,
    Gender,
    GenderFromJSON,
    GenderFromJSONTyped,
    GenderToJSON,
    Registration,
    RegistrationFromJSON,
    RegistrationFromJSONTyped,
    RegistrationToJSON,
} from './';

/**
 * 
 * @export
 * @interface Athlete
 */
export interface Athlete {
    /**
     * 
     * @type {number}
     * @memberof Athlete
     */
    athleteId?: number;
    /**
     * 
     * @type {string}
     * @memberof Athlete
     */
    accreditationNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Athlete
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Athlete
     */
    middleName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Athlete
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Athlete
     */
    fullName?: string | null;
    /**
     * 
     * @type {Gender}
     * @memberof Athlete
     */
    gender?: Gender;
    /**
     * 
     * @type {number}
     * @memberof Athlete
     */
    countryId?: number;
    /**
     * 
     * @type {Country}
     * @memberof Athlete
     */
    country?: Country;
    /**
     * 
     * @type {Array<Registration>}
     * @memberof Athlete
     */
    registrations?: Array<Registration> | null;
    /**
     * 
     * @type {number}
     * @memberof Athlete
     */
    disciplineId?: number;
    /**
     * 
     * @type {Discipline}
     * @memberof Athlete
     */
    discipline?: Discipline;
    /**
     * 
     * @type {boolean}
     * @memberof Athlete
     */
    deleted?: boolean;
    /**
     * 
     * @type {Event}
     * @memberof Athlete
     */
    event?: Event;
    /**
     * 
     * @type {Date}
     * @memberof Athlete
     */
    created?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Athlete
     */
    modified?: Date;
    /**
     * 
     * @type {string}
     * @memberof Athlete
     */
    createdBy?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Athlete
     */
    modifiedBy?: string | null;
}

export function AthleteFromJSON(json: any): Athlete {
    return AthleteFromJSONTyped(json, false);
}

export function AthleteFromJSONTyped(json: any, ignoreDiscriminator: boolean): Athlete {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'athleteId': !exists(json, 'athleteId') ? undefined : json['athleteId'],
        'accreditationNumber': !exists(json, 'accreditationNumber') ? undefined : json['accreditationNumber'],
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'middleName': !exists(json, 'middleName') ? undefined : json['middleName'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'fullName': !exists(json, 'fullName') ? undefined : json['fullName'],
        'gender': !exists(json, 'gender') ? undefined : GenderFromJSON(json['gender']),
        'countryId': !exists(json, 'countryId') ? undefined : json['countryId'],
        'country': !exists(json, 'country') ? undefined : CountryFromJSON(json['country']),
        'registrations': !exists(json, 'registrations') ? undefined : (json['registrations'] === null ? null : (json['registrations'] as Array<any>).map(RegistrationFromJSON)),
        'disciplineId': !exists(json, 'disciplineId') ? undefined : json['disciplineId'],
        'discipline': !exists(json, 'discipline') ? undefined : DisciplineFromJSON(json['discipline']),
        'deleted': !exists(json, 'deleted') ? undefined : json['deleted'],
        'event': !exists(json, 'event') ? undefined : EventFromJSON(json['event']),
        'created': !exists(json, 'created') ? undefined : (new Date(json['created'])),
        'modified': !exists(json, 'modified') ? undefined : (new Date(json['modified'])),
        'createdBy': !exists(json, 'createdBy') ? undefined : json['createdBy'],
        'modifiedBy': !exists(json, 'modifiedBy') ? undefined : json['modifiedBy'],
    };
}

export function AthleteToJSON(value?: Athlete | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'athleteId': value.athleteId,
        'accreditationNumber': value.accreditationNumber,
        'firstName': value.firstName,
        'middleName': value.middleName,
        'lastName': value.lastName,
        'fullName': value.fullName,
        'gender': GenderToJSON(value.gender),
        'countryId': value.countryId,
        'country': CountryToJSON(value.country),
        'registrations': value.registrations === undefined ? undefined : (value.registrations === null ? null : (value.registrations as Array<any>).map(RegistrationToJSON)),
        'disciplineId': value.disciplineId,
        'discipline': DisciplineToJSON(value.discipline),
        'deleted': value.deleted,
        'event': EventToJSON(value.event),
        'created': value.created === undefined ? undefined : (value.created.toISOString()),
        'modified': value.modified === undefined ? undefined : (value.modified.toISOString()),
        'createdBy': value.createdBy,
        'modifiedBy': value.modifiedBy,
    };
}

